import { Stack } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { Grid } from '@/components/layout/Grid';
import { EMPTY_CONTENT_HYPHEN } from '@/components/typography/placeholders';
import { GiftDataCard } from '@/modules/gifting/GiftDataCard';
import { ClientDetailsGiftingPage_HouseholdFragment } from '@/modules/gifting/graphql/ClientDetailsGiftingPage.generated';
import { useGiftingExemptionsForClient } from '@/modules/gifting/hooks/useGiftingExemptionsForClient';
import { ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';
import { formatCurrencyNoDecimals } from '@/utils/formatting/currency';

interface ClientDetailsExemptionsProps {
  household?: ClientDetailsGiftingPage_HouseholdFragment;
}

export function HouseholdExemptionsOverview({
  household,
}: ClientDetailsExemptionsProps) {
  const {
    availableLifetimeExemption,
    lifetimeExemptionSections,
    availableGstExemption,
    gstExemptionSections,
  } = useGiftingExemptionsForClient({
    household,
    returnNegativeValues: false,
  });

  const giftingPageUrl =
    household &&
    getCompletePathFromRouteKey(ROUTE_KEYS.HOUSEHOLD_DETAILS_GIFTING, {
      householdId: household.id,
    });

  return (
    <Stack sx={{ width: '100%', p: 2, pb: 0 }} gap={2}>
      <Grid container spacing={6}>
        <Grid item sm={6}>
          <GiftDataCard
            variant="transparent"
            cardSx={{
              p: 0,
            }}
            sections={lifetimeExemptionSections}
            label="Lifetime exemption"
            displayValue={
              availableLifetimeExemption
                ? formatCurrencyNoDecimals(availableLifetimeExemption)
                : EMPTY_CONTENT_HYPHEN
            }
          />
        </Grid>
        <Grid item sm={6}>
          <GiftDataCard
            variant="transparent"
            cardSx={{
              p: 0,
            }}
            sections={gstExemptionSections}
            label="GST exemption"
            displayValue={
              availableGstExemption
                ? formatCurrencyNoDecimals(availableGstExemption)
                : EMPTY_CONTENT_HYPHEN
            }
          />
        </Grid>
      </Grid>
      <Stack direction="row" justifyContent="end">
        <Button
          disabled={!giftingPageUrl}
          variant="secondary"
          size="sm"
          href={giftingPageUrl}
        >
          Track exemption usage
        </Button>
      </Stack>
    </Stack>
  );
}
